module.exports = __webpack_public_path__ + "img/bns.143c6a2a.svg";